module.exports = __webpack_public_path__ + "static/media/Anim_07.47cc55d3.fbx";